import { checkPermissions } from '../../layout/store'
import ListingHeader from '../../components/common/ListingTiles'
import HeaderSubTile from '../../components/app/Details/headerSubTile'
import { QbsTable } from 'qbs-react-grid'
import { calcWindowHeight } from '../../utilities/calcHeight'
import MultiStepModal from '../../components/common/multistepmodal'
import { useState } from 'react'

const MyCompany = () => {
  const [addCompany, setAddCompany] = useState<boolean>(false)
  const headerProps = {
    actionTitle: 'Add New',
    icon: 'plus',
  }
  const basicData = {
    title: 'My Companies',
    subtitle: 'Manage your companies & its branches from here.',
    icon: 'building-icon',
  }

  const ItemInfo = [
    { title: 'Total Worker', subtitle: '5800' },
    { title: 'Active Worker', subtitle: '5400' },
    { title: 'Inactive Worker', subtitle: '400' },
  ]

  const column = [
    {
      title: 'Name',
      field: 'first_name',
      fixed: true,
    },
  ]

  const handleClose = () => {
    setAddCompany(false)
  }
  const handleOpen = () => {
    setAddCompany(true)
  }
  return (
    <div>
      <ListingHeader
        data={basicData}
        onActionClick={handleOpen}
        actionProps={headerProps}
        checkPermission={checkPermissions('Employee', 'create')}
      />
      <HeaderSubTile ItemInfo={ItemInfo} />
      <div className=" px-5 py-4">
        <QbsTable
          data={[]}
          dataRowKey="id"
          toolbar={true}
          search={true}
          height={calcWindowHeight(260)}
          // emptyTitle="No records to display"
          columns={column}
        />
      </div>
      <MultiStepModal isOpen={addCompany} handleClose={handleClose} />
    </div>
  )
}

export default MyCompany
